import { useScroll, motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicePillarsSection from "@/components/ServicePillarsSection";
import ServicesSection from "@/components/ServicesSection";
import ShowcaseSection from "@/components/ShowcaseSection";
import ProcessSection from "@/components/ProcessSection";
import WhySpeedSection from "@/components/WhySpeedSection";
import FounderSection from "@/components/FounderSection";
import FAQSection from "@/components/FAQSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import CursorSpotlight from "@/components/CursorSpotlight";
import ErrorBoundary from "@/components/ErrorBoundary";

const ScrollProgressBar = () => {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-[60] h-[2px] origin-left bg-primary"
      style={{ scaleX: scrollYProgress }}
      aria-hidden="true"
    />
  );
};

const Index = () => (
  <>
    <ScrollProgressBar />
    <Navbar />
    <ErrorBoundary>
      <main>
        <CursorSpotlight />
        {/* Sticky-stacking slideshow: each section pins at z-index order,
            later sections cover earlier ones as user scrolls */}
        <HeroSection />
        <div data-scroll-target="about" aria-hidden="true" className="h-0" />
        <AboutSection />
        <ServicePillarsSection />
        <div data-scroll-target="services" aria-hidden="true" className="h-0" />
        <ServicesSection />
        <div data-scroll-target="showcase" aria-hidden="true" className="h-0" />
        <ShowcaseSection />
        <div data-scroll-target="process" aria-hidden="true" className="h-0" />
        <ProcessSection />
        <FounderSection />
        <WhySpeedSection />
        <div data-scroll-target="faq" aria-hidden="true" className="h-0" />
        <FAQSection />
        <div data-scroll-target="contact" aria-hidden="true" className="h-0" />
        <CTASection />
      </main>
    </ErrorBoundary>
    <Footer />
  </>
);

export default Index;
